import { Package, Plus, FileSpreadsheet } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { EmptyState, SecondaryButton } from "@/components/design-system";

/**
 * ProductsEmptyState — shown on the Ürünler page when the tenant has zero
 * products yet. Guides the merchant toward manual add (primary) and hints at
 * the upcoming XML feed import (secondary, disabled).
 */
export const ProductsEmptyState = ({ onAdd }) => (
    <EmptyState
        icon={Package}
        title={"Widget'ları Hangi Ürünlerde Göstereceğini Seç"}
        description={"SKU'larını yaz veya ürün URL'i yapıştır — biz meta / JSON-LD üzerinden otomatik doldururuz. XML feed'i olan markalar için otomatik senkron yakında."}
        action={{
            label: "Ürün Ekle",
            onClick: onAdd,
            icon: Plus,
            testId: "empty-add-btn",
        }}
        testId="products-empty-state"
        secondary={
            <div className="text-center">
                <SecondaryButton size="sm" disabled title="XML Importer yakında">
                    <FileSpreadsheet className="h-3.5 w-3.5" /> XML Feed Bağla
                    <Badge variant="outline" className="ml-1 text-[9px] border-info/40 text-info bg-info-soft">yakında</Badge>
                </SecondaryButton>
            </div>
        }
    />
);
